import { registration } from './registration';
import { root, id } from './uploaders';

export const uploaders = {
  ...root,
  id,
  registration,
};
